import React, { useEffect, useState } from "react";
import Modal from "../../../../parts/modal-new";
import QuestionCreate from "../../../athlete-portal/profile/components/QuestionCreate";
import QuestionDisplay from "../../../athlete-portal/profile/components/QuestionDisplay";
import {
  isUnchanged,
  validateCreateQuestion,
  validateCreateTemplate,
} from "../../../../utils/questionnaire-validations";
import submit from "submit-form";

const CreateQuestionnaire = ({ workflow, locals }) => {
  const { assert, flash } = locals;

  const [questions, setQuestions] = useState(
    workflow?.options?.questionnaire?.questions
      ? workflow?.options?.questionnaire?.questions
      : []
  );

  const [adding, setAdding] = useState(
    workflow?.options?.questionnaire?.questions ? false : true
  );

  const [editedQuestion, setEditedQuestion] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState({
    title: "",
    type: "short",
    body: { description: "Short Answer" },
  });
  const [addNew, setAddNew] = useState(true);
  const [firstEdition, setFirstEdition] = useState(
    workflow?.options?.questionnaire?.questions ? true : false
  );
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    if (!firstEdition && !adding) {
      setEditedQuestion(null);
      setCurrentQuestion({ title: "", type: "", body: {} });
      setAdding(true);
    }
    if (questions.length === 0) {
      setAddNew(true);
    }
  }, [questions]);

  const handleAddNew = () => {
    setFirstEdition(false);
    setAdding(true);
  };

  const handleSaveQuestion = () => {
    const isEditedValid = edit
      ? validateCreateQuestion(editedQuestion, assert, flash)
      : true;
    const isCreateValid = adding
      ? validateCreateQuestion(currentQuestion, assert, flash)
      : true;

    if (isCreateValid && isEditedValid) {
      const newQuestion = {
        ...currentQuestion,
        _id: `${currentQuestion.title}-${questions.length}`,
      };

      const updatedQuestions = edit
        ? getEditedQuestions(editedQuestion, newQuestion, adding)
        : [...questions, newQuestion];

      setQuestions(updatedQuestions);
      setEdit(false);
      setAdding(false);
      setAddNew(true);
    }
  };

  const getEditedQuestions = (editedQuestion, newQuestion, isCreateValid) => {
    const editedQuestions = questions.map((question) =>
      question._id === editedQuestion._id ? editedQuestion : question
    );

    const result = isCreateValid
      ? [...editedQuestions, { ...newQuestion }]
      : editedQuestions;

    return result;
  };

  const onEdit = (id) => {
    const question = questions.find((question) => question._id === id);
    setEditedQuestion(question);
    setEdit(true);
    setFirstEdition(false);
  };

  const onDelete = (id) => {
    const newQuestions = questions.filter((question) => question._id !== id);

    setQuestions(newQuestions);

    if (!newQuestions.length) {
      setEdit(false);
      setAdding(true);
      setAddNew(false);
    }
  };

  const handleSaveTemplate = () => {
    const questionsArray = getQuestionsArray();

    if (!questionsArray) return false;

    const newQuestions = questionsArray.map((question, index) => ({
      title: question.title,
      type: question.type,
      body: { ...question.body },
      _id: `question-${index}`,
    }));

    // Too lazy to do a new validation xd
    const newTemplate = {
      title: "Onboarding Questionnaire",
      questions: [...newQuestions],
    };

    if (validateCreateTemplate(newTemplate, assert, flash)) {
      submit("/actions/getting-started/questionnaire", {
        method: "POST",
        body: {
          value: [...newQuestions],
          workflow: workflow._id,
          option: "questionnaire",
        },
      });
    }
  };

  const getQuestionsArray = () => {
    const isCurrentQuestionUnchanged = isUnchanged(currentQuestion);
    const isEditedQuestionValid =
      editedQuestion && validateCreateQuestion(editedQuestion, assert, flash);
    const isCurrentQuestionValid =
      !isCurrentQuestionUnchanged &&
      validateCreateQuestion(currentQuestion, assert, flash);

    if (isCurrentQuestionUnchanged) {
      if (isEditedQuestionValid) {
        return getEditedQuestions(editedQuestion, {}, false);
      } else {
        return [...questions];
      }
    } else {
      if (isCurrentQuestionValid) {
        if (isEditedQuestionValid) {
          return getEditedQuestions(editedQuestion, currentQuestion, true);
        } else {
          return [...questions, { ...currentQuestion }];
        }
      } else {
        return false;
      }
    }
  };

  return (
    <Modal title={"Questionnaire"} className="add-checkin-template-modal">
      <div className="body">
        <div className="questionnaire-add-template-questions">
          {!!questions.length &&
            questions.map((question, index) => {
              if (editedQuestion && question._id === editedQuestion._id) {
                return (
                  <QuestionCreate
                    data={editedQuestion}
                    setData={setEditedQuestion}
                    isEdited={true}
                    key={`${question._id}`}
                    isOnboarding={true}
                  />
                );
              }

              return (
                <QuestionDisplay
                  body={question.body}
                  title={question.title}
                  type={question.type}
                  id={question._id}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  key={`${question._id}`}
                />
              );
            })}

          {adding && (
            <QuestionCreate
              data={currentQuestion}
              setData={setCurrentQuestion}
              isOnboarding={true}
            />
          )}

          {addNew && (
            <div className="template-modal-buttons add-acc-new-footer-buttons">
              <button
                data-button-type="outline"
                onClick={firstEdition ? handleAddNew : handleSaveQuestion}
              >
                Add New
              </button>
              <a
                href={`/actions/refresh?modal=&templateId=`}
                className=" only-show-mobile acc-btn add-new"
              >
                Cancel
              </a>
            </div>
          )}
        </div>
      </div>
      <footer>
        <div></div>
        <button onClick={handleSaveTemplate} data-button-type="primary">
          Save
        </button>
      </footer>
    </Modal>
  );
};

export default CreateQuestionnaire;
